<template>
  <vs-popup title="Documentos" :active.sync="open" @close="closeModal">
    <vs-alert
      v-if="$validator.errors.all().length > 0"
      color="danger"
      title="Atenção!!"
      active="true"
      class="my-3"
      style="height: auto !important"
    >
      <ul>
        <li
          class="mb-2"
          v-for="error in $validator.errors.all()"
          :key="error.id"
        >
          {{ error }}
        </li>
      </ul>
    </vs-alert>
    <form role="form" @submit.stop.prevent="prevent">
      <h4 class="mb-3 mt-5"></h4>
      <vs-alert class="text-center"
        >Envie todos documentos obrigatórios para continuar.</vs-alert
      >
      <div class="vx-row img">
        <div class="vx-col containerimg w-full my-4">
          <span
            class="ml-2 lg:ml-10 font-semibold"
            v-if="
              fotosDocumentos.obrigatorios &&
              fotosDocumentos.obrigatorios.length > 0
            "
          >
            Documentos Obrigatórios
          </span>

          <div
            v-for="foto in fotosDocumentos.obrigatorios"
            :key="foto.id_modelofoto"
          >
            <div class="flex flex-col items-center sm:px-16 px-2">
              <vs-button
                class="w-full my-1"
                :color="`${foto.nome ? 'success' : 'warning'}`"
                icon-pack="feather"
                icon="icon-paperclip"
                @click.stop.prevent="selecionaSelectTipoFoto(foto)"
              >
                {{ foto.nomePosicao }}
              </vs-button>
              <div>
                <vs-chip
                  v-if="
                    nomeArquivo &&
                    foto.id_modelofoto === formCadastro.foto.id_modelofoto
                  "
                  class="mb-5"
                >
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ nomeArquivo }}</span>
                </vs-chip>
              </div>
            </div>

            <div
              v-if="
                formCadastro.foto &&
                foto.id_modelofoto === formCadastro.foto.id_modelofoto
              "
              class="vx-col containerimg w-fulltext-center mb-6"
            >
              <center>
                <div v-if="extensaoArquivo === 'mp4' && urlArquivoServidor">
                  <video
                    class="video"
                    controls
                    muted
                    loop
                    :src="
                      urlArquivoLocal ? urlArquivoLocal : urlArquivoServidor
                    "
                  ></video>
                </div>
                <div v-if="extensaoArquivo === 'pdf'">
                  <img
                    src="../../../src/assets/images/elements/PDF_file_icon2.png"
                    width="100%"
                    style="max-width: 150px"
                  />
                  <p>
                    {{
                      extensaoArquivo === 'pdf' && urlArquivoLocal
                        ? nomeArquivo
                        : urlArquivoServidor.split('/').pop()
                    }}
                  </p>

                  <p></p>
                </div>

                <div
                  v-if="
                    extensaoArquivo === 'jpeg' ||
                    extensaoArquivo === 'jpg' ||
                    extensaoArquivo === 'png' ||
                    extensaoArquivo === 'gif'
                  "
                >
                  <img
                    :src="
                      urlArquivoLocal ? urlArquivoLocal : urlArquivoServidor
                    "
                    width="100%"
                    style="max-width: 250px"
                  />
                </div>
              </center>
              <input
                id="fileUpload"
                type="file"
                accept="video/*,image/*,.pdf"
                hidden
                v-on:change="selecionaFotoUpload"
              />
              <div class="w-full flex justify-end sm:px-16 px-2">
                <vs-button
                  color="success"
                  class="mr-3 mt-2"
                  @click="onSubmit"
                  :disabled="disableSubmitButton"
                  >Enviar</vs-button
                >
              </div>
            </div>
          </div>

          <span
            class="ml-2 lg:ml-10 font-semibold"
            v-if="
              fotosDocumentos.opcionais && fotosDocumentos.opcionais.length > 0
            "
          >
            Documentos Adicionais
          </span>

          <div
            v-for="foto in fotosDocumentos.opcionais"
            :key="foto.id_modelofoto"
          >
            <div class="flex flex-col items-center sm:px-16 px-2">
              <vs-button
                class="w-full my-1"
                :type="`${foto.nome ? 'border' : 'filled'}`"
                :color="`${foto.nome ? 'success' : 'warning'}`"
                icon-pack="feather"
                icon="icon-paperclip"
                @click.stop.prevent="selecionaSelectTipoFoto(foto)"
              >
                {{ foto.nomePosicao }}
              </vs-button>
              <div>
                <vs-chip
                  v-if="
                    nomeArquivo &&
                    foto.id_modelofoto === formCadastro.foto.id_modelofoto
                  "
                  class="mb-5"
                >
                  <vs-avatar icon-pack="feather" icon="icon-file" />
                  <span>{{ nomeArquivo }}</span>
                </vs-chip>
              </div>
            </div>

            <div
              v-if="
                formCadastro.foto &&
                foto.id_modelofoto === formCadastro.foto.id_modelofoto
              "
              class="vx-col containerimg w-fulltext-center mb-6"
            >
              <center>
                <div v-if="extensaoArquivo === 'mp4' && urlArquivoServidor">
                  <video
                    class="video"
                    controls
                    muted
                    loop
                    :src="
                      urlArquivoLocal ? urlArquivoLocal : urlArquivoServidor
                    "
                  ></video>
                </div>
                <div v-if="extensaoArquivo === 'pdf'">
                  <img
                    src="../../../src/assets/images/elements/PDF_file_icon2.png"
                    width="100%"
                    style="max-width: 150px"
                  />
                  <p>
                    {{
                      extensaoArquivo === 'pdf' && urlArquivoLocal
                        ? nomeArquivo
                        : urlArquivoServidor.split('/').pop()
                    }}
                  </p>

                  <p></p>
                </div>

                <div
                  v-if="
                    extensaoArquivo === 'jpeg' ||
                    extensaoArquivo === 'jpg' ||
                    extensaoArquivo === 'png' ||
                    extensaoArquivo === 'gif'
                  "
                >
                  <img
                    :src="
                      urlArquivoLocal ? urlArquivoLocal : urlArquivoServidor
                    "
                    width="100%"
                    style="max-width: 250px"
                  />
                </div>
              </center>
              <input
                id="fileUpload"
                type="file"
                accept="video/*,image/*,.pdf"
                hidden
                v-on:change="selecionaFotoUpload"
              />
              <div class="w-full flex justify-end sm:px-16 px-2">
                <vs-button
                  color="success"
                  class="mr-3 mt-2"
                  @click="onSubmit"
                  :disabled="disableSubmitButton"
                  >Enviar</vs-button
                >
              </div>
            </div>
          </div>

          <vs-alert
            v-if="urlArquivoServidor"
            color="warning"
            title="Atenção!"
            active="true"
            class="my-3"
            style="height: auto !important"
            >Ao enviar um novo arquivo, irá sobrescrever o existente.</vs-alert
          >
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full text-right mt-5">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="closeModal"
            >Cancelar</vs-button
          >

          <vs-button
            :disabled="!todasAsFotosObrigatoriasPreenchidas"
            :type="`${
              todasAsFotosObrigatoriasPreenchidas ? 'filled' : 'border'
            }`"
            @click.stop.prevent="proximoPasso"
            class="mr-3 mb-2"
            >Assinar</vs-button
          >

          <div v-if="showProgressBar">
            <span>Carregando... por favor, aguarde.</span>
            <vs-progress
              :height="8"
              :percent="progressPercentage"
              color="primary"
              >primary</vs-progress
            >
          </div>
        </div>
      </div>
    </form>
  </vs-popup>
</template>

<script>
import io from 'socket.io-client';
import locale from './../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import service from '../../services';
export default {
  props: {
    dadosProposta: {
      type: Object,
    },
    idProposta: {
      type: Array,
    },
    openModal: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    openModal(value) {
      if (value) {
        this.open = value;
        this.idFrota = this.dadosProposta.idFrota;
        this.buscarDocumentosVistoria();
      }
    },
  },
  data() {
    return {
      open: false,
      extensaoArquivo: null,
      progressPercentage: null,
      showProgressBar: false,
      tamanhoParcialArquivoAcumulado: null,
      tamanhoParcialArquivo: null,
      tamanhoTotalArquivoLocal: null,
      reqQuery: null,
      urlArquivoLocal: null,
      arquivoLocal: null,
      disableChooseButton: true,
      disableSubmitButton: true,
      aguardeCadastro: false,
      urlArquivoServidor: null,
      fotoAtual: 0,
      currentPage: 1,
      pageCount: 0,
      hasImage: false,
      files: new FormData(),
      image: null,
      languages: lang,
      tipoFoto: null,
      nomeArquivo: null,
      nomeRegulamento: null,
      funcoesValicao: null,
      fotosDocumentos: { obrigatorios: [], opcionais: [] },
      documentosRequeridos: [
        'CNH',
        'Selfie',
        'Contrato Social',
        'Comprovante de Endereço',
        'Documento Anexo',
      ],
      formCadastro: {
        observacaoVistoria: null,
        idEmpresa: null,
        foto: null,
        idProposta: null,
        idFrota: null,
      },
      socket: null,
      idFrota: null,
    };
  },
  computed: {
    todasAsFotosObrigatoriasPreenchidas() {
      return this.fotosDocumentos.obrigatorios.every((foto) => foto.nome);
    },
  },
  methods: {
    prevent() {
      return;
    },
    async buscarDocumentosVistoria() {
      this.$vs.loading();
      const objSend = {};
      objSend.idProposta = this.dadosProposta.propostas[0].idProposta;
      objSend.idEmpresa = this.dadosProposta.idEmpresa;
      objSend.idGrupo = this.dadosProposta.propostas[0].idGrupo;
      objSend.idTipoFipe =
        this.dadosProposta.propostas[0].dadosVeiculo.codTipoVeiculo;
      objSend.isZero = this.dadosProposta.propostas[0].isZero;
      try {
        const { data: fotos } = await service.post(
          'Vistoria',
          'listarTiposFotos',
          objSend,
        );
        const arquivosRequeridos = fotos.filter((foto) =>
          this.documentosRequeridos.includes(foto.nomePosicao),
        );
        this.fotosDocumentos.obrigatorios = arquivosRequeridos.filter(
          (foto) => foto.obrigatorio,
        );
        this.fotosDocumentos.opcionais = arquivosRequeridos.filter(
          (foto) => !foto.obrigatorio,
        );
      } catch (e) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: e,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async selecionaSelectTipoFoto(foto) {
      this.disableSubmitButton = true;
      this.formCadastro.foto = foto;
      if (!this.formCadastro.foto) {
        this.urlArquivoLocal = null;
        this.nomeArquivo = null;
        this.disableSubmitButton = true;
        this.disableChooseButton = true;
        this.urlArquivoServidor = null;
        this.extensaoArquivo = null;
        return;
      }
      this.urlArquivoLocal = null;
      this.urlArquivoServidor = foto.nome;
      this.extensaoArquivo = null;
      this.nomeArquivo = null;
      this.formCadastro.observacaoVistoria = foto.observacaoVistoria;
      this.tipoFoto = foto.tipoFoto;
      this.formCadastro.idProposta = this.idProposta;

      if (this.formCadastro.foto) this.disableChooseButton = false;

      await this.verificaExtensaoArquivo();
      this.chooseFiles();
    },
    selecionaFotoUpload(event) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;

      this.arquivoLocal = files;
      this.tamanhoTotalArquivoLocal = this.arquivoLocal[0].size;
      this.urlArquivoLocal = URL.createObjectURL(this.arquivoLocal[0]);

      if (this.arquivoLocal) this.disableSubmitButton = false;

      this.files.set('file', event.target.files[0], event.target.files[0].name);
      this.formCadastro.idProposta = this.idProposta;
      this.formCadastro.idFrota = this.idFrota;
      this.nomeArquivo = files[0].name;

      this.verificaExtensaoArquivo();
    },
    successUpload() {
      this.$vs.notify({
        color: 'success',
        title: 'Upload Success',
        text: 'Lorem ipsum dolor sit amet, consectetur',
      });
    },
    chooseFiles() {
      document.getElementById('fileUpload').click();
    },
    chooseFiles2() {
      document.getElementById('fileUpload2').click();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    verificaExtensaoArquivo() {
      if (this.urlArquivoLocal) {
        const ext = this.nomeArquivo.split('.').pop();
        this.extensaoArquivo = ext;
        this.tipoFoto = ext;
        return true;
      }

      if (this.urlArquivoServidor && !this.urlArquivoLocal) {
        const ext = this.urlArquivoServidor.split('.').pop();
        this.extensaoArquivo = ext;
        this.tipoFoto = ext;
        return true;
      }
      return false;
    },
    async onSubmit() {
      if (!this.formCadastro.foto) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Selecione o Tipo de Foto Corretamente`,
          color: 'danger',
        });
        return;
      }

      this.formCadastro.isUpload = true;
      this.showProgressBar = true;
      this.disableSubmitButton = true;
      this.disableChooseButton = true;
      try {
        const { urlImage } = await service.upload(
          'upload-v2',
          'Vistoria/' + this.idFrota + `?room=${this.reqQuery}`,
          this.files,
        );
        this.formCadastro.url = urlImage;
        this.urlArquivoServidor = urlImage;
        this.formCadastro.idProspect =
          this.dadosProposta.dadosCliente.idProspect;
        this.aguardeCadastro = true;
        this.showProgressBar = true;
        this.disableSubmitButton = true;
        try {
          await service.post(
            'Vistoria',
            'atualizar-foto-multi-vistoria-upload',
            this.formCadastro,
          );
          this.aguardeCadastro = false;
          this.showProgressBar = false;
          this.disableSubmitButton = false;
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Dados Atualizados com sucesso',
            color: 'success',
          });
          this.formCadastro = {
            idEmpresa: null,
            foto: null,
            idProposta: null,
            observacaoVistoria: null,
          };
          this.nomeArquivo = null;
          this.progressPercentage = null;
          this.tamanhoParcialArquivo = null;
          this.tamanhoParcialArquivoAcumulado = null;
          this.urlArquivoLocal = null;
          this.urlArquivoServidor = null;
          this.extensaoArquivo = null;
          this.buscarDocumentosVistoria();
        } catch {
          this.aguardeCadastro = false;
          this.showProgressBar = false;
          this.disableSubmitButton = false;
          // this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível atualizar os Dados',
            color: 'danger',
          });
        }
      } catch (e) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: e,
          color: 'danger',
        });
      }
    },

    onReset(evt) {
      evt.preventDefault();
      (this.disableChooseButton = true),
        (this.disableSubmitButton = true),
        (this.formCadastro = {
          idEmpresa: null,
          foto: null,
          idProposta: null,
        });
      this.urlArquivoServidor = null;
      this.urlArquivoLocal = null;
      this.extensaoArquivo = null;
      this.tipoFoto = null;
      this.nomeArquivo = null;
      this.$nextTick(() => {
        this.show = true;
      });
      this.$emit('fechaModalUploadManual');
    },
    calculatePercentage(totalValue, actualValue) {
      const percentage = (100 * actualValue) / totalValue;
      this.progressPercentage = percentage;
      return parseInt(this.progressPercentage);
    },
    connectWebSocket() {
      this.socket = io(process.env.VUE_APP_SERVER_SOCKET);
      this.socket.on('message', (res) => {
        if (res.length) {
          this.tamanhoParcialArquivo = res.length;

          this.tamanhoParcialArquivoAcumulado =
            this.tamanhoParcialArquivoAcumulado + this.tamanhoParcialArquivo;

          this.progressPercentage = this.calculatePercentage(
            this.tamanhoTotalArquivoLocal,
            this.tamanhoParcialArquivoAcumulado,
          );
        }
      });
      this.socket.on('join_room_response', () => {
        const dateTime = Date.now();
        this.files.set(
          'query',
          `upload-multi-vistoria-${this.idFrota}-room${dateTime}`,
        );
      });
      this.socket.on('connect_error', () => {});
      this.socket.on('connect', () => {
        const dateTime = Date.now();
        this.reqQuery = `upload-multi-vistoria-${this.idFrota}-room${dateTime}`;
        this.socket.emit('join_room', this.reqQuery);
      });
    },
    closeModal() {
      this.open = false;
      this.$emit('closeModalDocumentos');
    },
    proximoPasso() {
      this.open = false;
      this.$emit('assinar');
    },
  },
  created() {
    this.$validator.localize('ptBr', locale);
  },
  mounted() {
    this.connectWebSocket();
  },
  destroyed() {
    if (this.socket) {
      this.socket.disconnect();
    }
  },
};
</script>
<style>
.vs-popup {
  max-height: 85vh;
}

#fileInput {
  display: none;
}
.img label {
  width: 100%;
  font-weight: normal;
}

.img .containericone {
  text-align: center;
  border-radius: 10px;
  padding: 10px 20px;
  -webkit-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 40px -20px rgba(0, 0, 0, 0.75);
  width: min-content;
  margin-top: 25px;
  margin-left: 43%;
  border: 1px solid #ccc;
}

.video {
  max-height: 140px;
}

@media (max-width: 1100px) {
  .video {
    max-height: 100px !important;
  }
}

@media (max-width: 1395px) {
  .video {
    max-height: 90px !important;
  }
}

.img .icone {
  font-size: 50px;
  color: #333;
}
</style>
